import { render, staticRenderFns } from "./ProjelerListe.vue?vue&type=template&id=01485c50&scoped=true&"
import script from "./ProjelerListe.vue?vue&type=script&lang=js&"
export * from "./ProjelerListe.vue?vue&type=script&lang=js&"
import style0 from "./ProjelerListe.vue?vue&type=style&index=0&id=01485c50&lang=scss&scoped=true&"
import style1 from "./ProjelerListe.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01485c50",
  null
  
)

export default component.exports